



























import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import AssetList from "./AssetsList.vue";

@Component({
  components: {
    AssetList
  }
})
class Assets extends Vue {
  @Getter("auth/isLogged") logged;

  @Getter("wallet/mixin/getMergedAssets") mixinAssets;

  get assets() {
    return this.mixinAssets;
  }

  handleConnect() {
    this.$emit("login", "mixin");
  }
}
export default Assets;
